import * as styles from "./loading.css";

export const Loading = () => (
  <div className={styles.container}>
    <div className={styles.content}></div>
  </div>
);
